const scrollToElement = (element: HTMLElement) => {
  const headerOffset = document.getElementById('site-header')?.offsetHeight ?? 0;
  const elementPosition = element.getBoundingClientRect().top;
  const offsetPosition = elementPosition + window.scrollY - headerOffset - 50;

  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth',
  });
};

export default scrollToElement;
